import React, { useState } from 'react'
import CompletedInstrumentsListItem from './CompletedInstrumentsListItem'

const CompletedInstrumentsList = props => {
  const {
    completedInstruments = [],
    studyId,
    participantId,
    setSubmissionSurvey,
    formatSubmissionSurvey,
    selectedLocale
  } = props

  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className='completed-instruments'>
      <div className='completed-instruments-title-box'>
        <div className='completed-instruments-title'>Completed instruments</div>
        <div
          className='completed-instruments-expand-btn'
          onClick={() => setIsExpanded(!isExpanded)}>
          <i
            className={isExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}
          />
        </div>
      </div>
      {isExpanded && (
        <div className='completed-instruments-list'>
          {completedInstruments.map((completedInstrument, index) => (
            <CompletedInstrumentsListItem
              key={index}
              completedInstrument={completedInstrument}
              studyId={studyId}
              participantId={participantId}
              setSubmissionSurvey={setSubmissionSurvey}
              formatSubmissionSurvey={formatSubmissionSurvey}
              selectedLocale={selectedLocale}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default CompletedInstrumentsList
